import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// import LanguageDetector from 'i18next-browser-languagedetector';
import enJSON from './translations/en';
import esJSON from './translations/es';
import frJSON from './translations/fr';

const resources = {
	en: { translation: enJSON },
	es: { translation: esJSON },
	fr: { translation: frJSON },
};

i18n
	// .use(LanguageDetector)
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		keySeparator: false,
		lng: 'en',
		fallbackLng: 'en',
		react: {
			useSuspense: true,
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
